module.exports = __webpack_public_path__ + "static/media/three.94ecd5ff.jpg";